import { defaultCtx } from "~/lib/AjaxCtx"

export default class PollService {
    constructor(ctx) {
        this.$http = ctx || defaultCtx
    }
    /**
     * Starts the poll and fetches the attempt data
     */
    async start(userActivityId, attemptId = null) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/start`,
            {
                method: "POST",
                body: JSON.stringify({ attemptId: attemptId }),
            }
        )
    }

    /**
     * Saves the poll answers
     */
    async save(userActivityId, attemptId, answers) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/save`,
            {
                method: "POST",
                body: JSON.stringify({
                    attemptId: attemptId,
                    answers,
                }),
            }
        )
    }

    /**
     * Corrects a set of questions of the poll and fetches the attempt data including the corrections (if relevant)
     */
    async correct(userActivityId, attemptId, answers) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/correct`,
            {
                method: "POST",
                body: JSON.stringify({
                    attemptId: attemptId,
                    answers,
                }),
            }
        )
    }

    /**
     * Finishes the poll and updates the attempt data including the corrections (if relevant)
     */
    async finish(userActivityId, attemptId, answers) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/finish`,
            {
                method: "POST",
                body: JSON.stringify({
                    attemptId: attemptId,
                    answers,
                }),
            }
        )
    }
}
